import Vue from 'vue'

export function registerGlobalComponents() {
    // Define the path to the folder with components
    const requireComponent = require.context(
        // Relative path to the components folder
        '@/components',
        // Whether to recursively search subfolders
        true,
        // Regular expression to match `.vue` files
        /\.vue$/
    )

    // Object to store folders where `Index.vue` was found
    const indexFolders = {}

    // First iteration: Check if a folder contains `Index.vue`
    requireComponent.keys().forEach(fileName => {
        // Check if the file is `Index.vue`
        if (fileName.endsWith('Index.vue')) {
            // Get the folder path
            const folder = fileName.split('/').slice(0, -1).join('/')
            // Mark that this folder has an `Index.vue`
            indexFolders[folder] = true

            // Get the component
            const componentConfig = requireComponent(fileName)

            // Set the component name based on the folder
            const componentName = componentConfig.default.name || folder.split('/').pop()

            // Global registration of `Index.vue`
            Vue.component(
                componentName,
                componentConfig.default || componentConfig
            )
        }
    })

    // Second iteration: Register other files only if the folder doesn't have `Index.vue`
    requireComponent.keys().forEach(fileName => {
        // Get the folder path
        const folder = fileName.split('/').slice(0, -1).join('/')

        // Skip other files if the folder has `Index.vue`
        if (indexFolders[folder]) return

        // Get the component
        const componentConfig = requireComponent(fileName)

        // Get the component name based on the file name
        const componentName = componentConfig.default.name || fileName
            .split('/')
            .pop()
            .replace(/\.\w+$/, '')

        // Global registration of the component
        Vue.component(
            componentName,
            componentConfig.default || componentConfig
        )
    })
}
